export default __webpack_public_path__ + "static/media/us-or.3b5725b9.svg";